import React from 'react';
import styles from './cardItem.module.css';
import { Link } from 'react-router-dom';
import handle from '../../../../../lib/handle';

export default ({ srcArr, title, number, ck }: { srcArr: string[]; title: string; number: number; ck: Function }) => {
  const { arr3, arr4 } = handle();
  function linkStr() {
    const index = arr4.indexOf(title);
    if (index > -1) {
      return `/classify?type=${arr3[index]}`;
    }
    return '';
  }

  return (
    <>
      <Link
        to={linkStr()}
        className={styles.cardItem}
        onClick={() => {
          ck && ck(title);
        }}
      >
        <div className={styles.left}>
          <div className={styles.cardTitle}>{title}</div>
          {number ? <div className={styles.cardNumber}>{number}</div> : ''}
        </div>
        <div className={styles.right}>
          {srcArr[0] && <img src={srcArr[0]} className={styles.rightImg1}></img>}
          {srcArr[1] && <img src={srcArr[1]} className={styles.rightImg2}></img>}
          {srcArr[2] && <img src={srcArr[2]} className={styles.rightImg3}></img>}
        </div>
      </Link>
    </>
  );
};
